(function (angular) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive('tyQueryStringToScope', ['$location', function ($location) {
            return {
                link: function (scope, elm, attrs) {
                    var param = attrs.tyQueryStringToScopeIn || '';
                    var scopeExpression = attrs.tyQueryStringToScopeOut;

                    if (!scopeExpression) {
                        throw new Error('tyQueryStringToScope directive is missing attribute tyQueryStringToScopeOut');
                    }

                    var type = attrs.type || 'select'; //defaults to select
                    var compareVal = attrs.tyQueryStringToScopeCompareValue || '';

                    if (typeof $location.search()[param] !== "undefined") {
                        var name = $location.search()[param].toLowerCase();

                        switch (type) {
                            case "select": {
                                var lookupList = scope[attrs.tyQueryStringToScopeLookupList];
                                lookupList.forEach(function (currentValue) {
                                    if (currentValue.Text.toLowerCase() === name) {
                                        scope.tmpCurrentValue = currentValue.Value;

                                        scope.$eval(
                                            scopeExpression + ' = tmpCurrentValue; ' +
                                            'tmpCurrentValue = undefined;'
                                        );
                                    }
                                });
                                break;
                            }

                            case "radio": {
                                if (name === compareVal.toLowerCase()) {
                                    scope.tmpCurrentValue = elm.attr('value');
                                    scope.$eval(scopeExpression + ' = tmpCurrentValue');
                                    delete scope.tmpCurrentValue;
                                }
                                break;
                            }

                            case "hidden": {
                                scope.tmpCurrentValue = name;
                                scope.$eval(scopeExpression + ' = tmpCurrentValue');
                                delete scope.tmpCurrentValue;
                                break;
                            }

                        }
                    }
                }
            };
        }]);
})(window.angular);
